import type { ProjectType } from '~/model/ProjectType';
import { InteractionDetailSkeleton } from '@/app/[locale]/(entity)/components/interaction/loading/InteractionDetailSkeleton';
import { TabsFilterValue } from '../types/project/tabs';
import { RadioButtonSVG } from './steps/ProjectSteps';
import { ProjectStepsStatus } from './steps/ProjectStepsStatus';

export function StepSkeleton() {
  return (
    <div className="step" data-testid="step-skeleton">
      <div className="step__timeline step__timeline--last" />
      <div className="step__timeline-icon">
        <RadioButtonSVG />
        <div className="step__timeline-icon-background" />
      </div>
      <div className="step__card">
        <div className="project-card__block">
          <span
            className="vtmn-skeleton vtmn-skeleton_line"
            style={{ width: '100%', height: '142px' }}
          />
        </div>
      </div>
    </div>
  );
};

const Loading = ({
  filter,
  project,
}: {
  filter?: TabsFilterValue | number;
  project: ProjectType;
}) => {
  switch (filter) {
    case TabsFilterValue.STEPS:
      return (
        <div data-testid="steps" className="steps centered-content">
          <div className="project-status">
            <div className="project-status__hidden-block" />
            <div className="project-status__block">
              <ProjectStepsStatus project={project} />
            </div>
          </div>
          <StepSkeleton />
          <div style={{ minHeight: '100vh' }} />
        </div>
      );
    case TabsFilterValue.NEWS:
      return (
        <div className="announcement-list centered-content" data-testid="news">
          <ul className="interactions-list__container">
            {[...Array.from({ length: 3 }).keys()].map(key => (
              <li key={key}>
                <div className="project-card">
                  <div className="announcement-card">
                    <div className="announcement-card__header">
                      <span className="vp-title-l announcement-card__title">
                        <span
                          className="vtmn-skeleton vtmn-skeleton_line"
                          style={{ width: '100%', height: '44px' }}
                        />
                      </span>
                      <div className="vp-body-l announcement-card__description__preview">
                        {[...Array.from({ length: 5 }).keys()].map(key => (
                          <p
                            key={key}
                            className="vtmn-skeleton vtmn-skeleton_line"
                            style={{
                              width: `${Math.floor(Math.random() * (100 - 80 + 1) + 80)}%`,
                              height: '24px',
                            }}
                          />
                        ))}
                      </div>
                      <div className="author">
                        <span className="author__avatar">
                          <span
                            className="vtmn-skeleton vtmn-skeleton_avatar"
                            style={{ width: '40px', height: '40px' }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      );
    default:
      return (
        <InteractionDetailSkeleton />
      );
  }
};

export default Loading;
